import { useIntl } from "react-intl";

import type { MemberItem } from "~/client/components/search/hooks/useMemberSearchResult";
import { LinkStyledButton } from "~/client/components/search/IncrementalSearchResult/LinkStyledButton";
import { ListFooter } from "~/client/components/search/IncrementalSearchResult/ListFooter";
import { Member } from "~/client/components/search/IncrementalSearchResult/Member";
import { friendlyUserPath } from "~/client/generated/routes";
import type { ListItemSelection } from "~/client/hooks/useSelectListItemByKey";
import type { ConnectionWithTotalCount } from "~/client/utils/relay";

interface Props {
  listIndex: number;
  items: ConnectionWithTotalCount<MemberItem>;
  onViewAll: () => void;
  listItemSelection: ListItemSelection;
  query: string;
}
export const MemberList: React.FC<Props> = ({ listIndex, items, query, onViewAll, listItemSelection }) => {
  const intl = useIntl();

  const selected = items.edges.find((_, itemIndex) => listItemSelection.isItemSelected({ listIndex, itemIndex }));

  if (selected && listItemSelection.isSubmitting) {
    location.assign(friendlyUserPath(selected.node.account));
  }

  return (
    <>
      <ul>
        {items.edges.map((e) => (
          <Member
            key={e.node.account}
            item={e.node}
            isSelected={e.node.account === selected?.node.account}
            query={query}
          />
        ))}
      </ul>
      {items.totalCount > items.edges.length && (
        <ListFooter>
          <LinkStyledButton text={intl.formatMessage({ id: "incrementalSearchResult.viewAll" })} onClick={onViewAll} />
        </ListFooter>
      )}
    </>
  );
};
